/**
 * @fileoverview gRPC-Web generated client stub for fleet
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!


/* eslint-disable */
// @ts-nocheck


import * as grpcWeb from 'grpc-web';

import * as common_pb from './common_pb';
import * as route_plan_pb from './route_plan_pb';
import * as route_proposal_pb from './route_proposal_pb';

import {
  ConfirmOvcEventRequest,
  ConfirmOvcEventResponse,
  ConfirmRouteProposalRequest,
  ConfirmRouteProposalResponse,
  GetRouteProposalRequest,
  GetRouteProposalResponse,
  ListWaypointsRequest,
  ListWaypointsResponse,
  SendPulloverRequest,
  SendPulloverResponse,
  SendWaypointRequest,
  SendWaypointResponse,
  SetAutonomyReadyRequest,
  SetAutonomyReadyResponse} from './remote-monitor-command_pb';

export class RemoteMonitorCommandServiceClient {
  client_: grpcWeb.AbstractClientBase;
  hostname_: string;
  credentials_: null | { [index: string]: string; };
  options_: null | { [index: string]: string; };

  constructor (hostname: string,
               credentials?: null | { [index: string]: string; },
               options?: null | { [index: string]: string; }) {
    if (!options) options = {};
    if (!credentials) credentials = {};
    options['format'] = 'text';

    this.client_ = new grpcWeb.GrpcWebClientBase(options);
    this.hostname_ = hostname;
    this.credentials_ = credentials;
    this.options_ = options;
  }

  methodInfoListWaypoints = new grpcWeb.AbstractClientBase.MethodInfo(
    ListWaypointsResponse,
    (request: ListWaypointsRequest) => {
      return request.serializeBinary();
    },
    ListWaypointsResponse.deserializeBinary
  );

  listWaypoints(
    request: ListWaypointsRequest,
    metadata: grpcWeb.Metadata | null): Promise<ListWaypointsResponse>;

  listWaypoints(
    request: ListWaypointsRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: ListWaypointsResponse) => void): grpcWeb.ClientReadableStream<ListWaypointsResponse>;

  listWaypoints(
    request: ListWaypointsRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.Error,
               response: ListWaypointsResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/fleet.RemoteMonitorCommandService/ListWaypoints',
        request,
        metadata || {},
        this.methodInfoListWaypoints,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/fleet.RemoteMonitorCommandService/ListWaypoints',
    request,
    metadata || {},
    this.methodInfoListWaypoints);
  }

  methodInfoSendWaypoint = new grpcWeb.AbstractClientBase.MethodInfo(
    SendWaypointResponse,
    (request: SendWaypointRequest) => {
      return request.serializeBinary();
    },
    SendWaypointResponse.deserializeBinary
  );

  sendWaypoint(
    request: SendWaypointRequest,
    metadata: grpcWeb.Metadata | null): Promise<SendWaypointResponse>;

  sendWaypoint(
    request: SendWaypointRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: SendWaypointResponse) => void): grpcWeb.ClientReadableStream<SendWaypointResponse>;

  sendWaypoint(
    request: SendWaypointRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.Error,
               response: SendWaypointResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/fleet.RemoteMonitorCommandService/SendWaypoint',
        request,
        metadata || {},
        this.methodInfoSendWaypoint,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/fleet.RemoteMonitorCommandService/SendWaypoint',
    request,
    metadata || {},
    this.methodInfoSendWaypoint);
  }

  methodInfoGetRouteProposal = new grpcWeb.AbstractClientBase.MethodInfo(
    GetRouteProposalResponse,
    (request: GetRouteProposalRequest) => {
      return request.serializeBinary();
    },
    GetRouteProposalResponse.deserializeBinary
  );

  getRouteProposal(
    request: GetRouteProposalRequest,
    metadata: grpcWeb.Metadata | null): Promise<GetRouteProposalResponse>;

  getRouteProposal(
    request: GetRouteProposalRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: GetRouteProposalResponse) => void): grpcWeb.ClientReadableStream<GetRouteProposalResponse>;

  getRouteProposal(
    request: GetRouteProposalRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.Error,
               response: GetRouteProposalResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/fleet.RemoteMonitorCommandService/GetRouteProposal',
        request,
        metadata || {},
        this.methodInfoGetRouteProposal,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/fleet.RemoteMonitorCommandService/GetRouteProposal',
    request,
    metadata || {},
    this.methodInfoGetRouteProposal);
  }

  methodInfoConfirmRouteProposal = new grpcWeb.AbstractClientBase.MethodInfo(
    ConfirmRouteProposalResponse,
    (request: ConfirmRouteProposalRequest) => {
      return request.serializeBinary();
    },
    ConfirmRouteProposalResponse.deserializeBinary
  );

  confirmRouteProposal(
    request: ConfirmRouteProposalRequest,
    metadata: grpcWeb.Metadata | null): Promise<ConfirmRouteProposalResponse>;

  confirmRouteProposal(
    request: ConfirmRouteProposalRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: ConfirmRouteProposalResponse) => void): grpcWeb.ClientReadableStream<ConfirmRouteProposalResponse>;

  confirmRouteProposal(
    request: ConfirmRouteProposalRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.Error,
               response: ConfirmRouteProposalResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/fleet.RemoteMonitorCommandService/ConfirmRouteProposal',
        request,
        metadata || {},
        this.methodInfoConfirmRouteProposal,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/fleet.RemoteMonitorCommandService/ConfirmRouteProposal',
    request,
    metadata || {},
    this.methodInfoConfirmRouteProposal);
  }

  methodInfoSetAutonomyReady = new grpcWeb.AbstractClientBase.MethodInfo(
    SetAutonomyReadyResponse,
    (request: SetAutonomyReadyRequest) => {
      return request.serializeBinary();
    },
    SetAutonomyReadyResponse.deserializeBinary
  );

  setAutonomyReady(
    request: SetAutonomyReadyRequest,
    metadata: grpcWeb.Metadata | null): Promise<SetAutonomyReadyResponse>;

  setAutonomyReady(
    request: SetAutonomyReadyRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: SetAutonomyReadyResponse) => void): grpcWeb.ClientReadableStream<SetAutonomyReadyResponse>;

  setAutonomyReady(
    request: SetAutonomyReadyRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.Error,
               response: SetAutonomyReadyResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/fleet.RemoteMonitorCommandService/SetAutonomyReady',
        request,
        metadata || {},
        this.methodInfoSetAutonomyReady,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/fleet.RemoteMonitorCommandService/SetAutonomyReady',
    request,
    metadata || {},
    this.methodInfoSetAutonomyReady);
  }

  methodInfoConfirmOvcEvent = new grpcWeb.AbstractClientBase.MethodInfo(
    ConfirmOvcEventResponse,
    (request: ConfirmOvcEventRequest) => {
      return request.serializeBinary();
    },
    ConfirmOvcEventResponse.deserializeBinary
  );

  confirmOvcEvent(
    request: ConfirmOvcEventRequest,
    metadata: grpcWeb.Metadata | null): Promise<ConfirmOvcEventResponse>;

  confirmOvcEvent(
    request: ConfirmOvcEventRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: ConfirmOvcEventResponse) => void): grpcWeb.ClientReadableStream<ConfirmOvcEventResponse>;

  confirmOvcEvent(
    request: ConfirmOvcEventRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.Error,
               response: ConfirmOvcEventResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/fleet.RemoteMonitorCommandService/ConfirmOvcEvent',
        request,
        metadata || {},
        this.methodInfoConfirmOvcEvent,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/fleet.RemoteMonitorCommandService/ConfirmOvcEvent',
    request,
    metadata || {},
    this.methodInfoConfirmOvcEvent);
  }

  methodInfoSendPullover = new grpcWeb.AbstractClientBase.MethodInfo(
    SendPulloverResponse,
    (request: SendPulloverRequest) => {
      return request.serializeBinary();
    },
    SendPulloverResponse.deserializeBinary
  );

  sendPullover(
    request: SendPulloverRequest,
    metadata: grpcWeb.Metadata | null): Promise<SendPulloverResponse>;

  sendPullover(
    request: SendPulloverRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: SendPulloverResponse) => void): grpcWeb.ClientReadableStream<SendPulloverResponse>;

  sendPullover(
    request: SendPulloverRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.Error,
               response: SendPulloverResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/fleet.RemoteMonitorCommandService/SendPullover',
        request,
        metadata || {},
        this.methodInfoSendPullover,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/fleet.RemoteMonitorCommandService/SendPullover',
    request,
    metadata || {},
    this.methodInfoSendPullover);
  }

}

